import { useEffect } from 'react';

const BASE_TITLE = 'Design MD Generator';

/** Keeps the browser tab title in sync with the current view. */
export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `${title} - ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
}
